//
// A fluxible store that keeps track of the core brief fields.
//

import { BaseStore } from 'fluxible/addons';

export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

const getExperimentsSet = (experiments = {}) => {
    const set = new Set();

    Object.keys(experiments).forEach(key => set.add(`${key}:${experiments[key].variant}`));

    return set;
}

class DraftStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.saveInProgress = false;
        this.seenEmailModal = false;
        this.draftHash = null;
        this.categoryKey = null;
    }

    load(payload) {
        this.experiments = getExperimentsSet(payload.body.experiments);
        this.notifyStatus = null;
        this.categoryKey = payload.category_key;
        this.draftHash = payload.draft_hash;
        this.seenEmailModal = payload.seen_email_modal || false;
        this.emitChange();
    }

    handleSuccess({ notify = false }) {
        this.saveInProgress = false;
        this.notifyStatus = notify ? STATUS_SUCCESS : null;
        this.emitChange();
    }

    clearStatus() {
        this.notifyStatus = null;
        this.error = null;
        this.emitChange();
    }

    handleError() {
        this.notifyStatus = STATUS_ERROR;
        this.error = true;
        this.saveInProgress = false;
        this.emitChange();
    }

    startSaving() {
        this.saveInProgress = true;
        this.emitChange();
    }

    isSeenEmailModal() {
        return this.seenEmailModal;
    }

    setSeenEmailModal() {
        this.seenEmailModal = true;
        this.emitChange();
    }

    getState() {
        return {
            saveInProgress: this.saveInProgress,
            experiments: this.experiments,
            error: this.error,
            draftHash: this.draftHash,
            categoryKey: this.categoryKey
        };
    }
}

DraftStore.storeName = 'DraftStore';
DraftStore.handlers = {
    SAVE_DRAFT_STARTED: 'startSaving',
    SAVE_DRAFT_FAILURE: 'handleError',
    SAVE_DRAFT_SUCCESS: 'handleSuccess',
    CLEAR_STATUS: 'clearStatus',
    UPDATE_DRAFT_STEP: 'clearStatus',
    LOAD_DRAFT_DATA: 'load',
    DISMISS_EMAIL_COLLECTION: 'setSeenEmailModal',
    SUBMIT_EMAIL_COLLECTION: 'setSeenEmailModal',
};

export default DraftStore;



// WEBPACK FOOTER //
// ./js/launch/stores/DraftStore.js